export { default } from "./GuidedHighlightingTeacherInfoPopup";
